// src/services/bi/dashboardAiService.js
import api from '../api';  // ← api.js a déjà baseURL: 'http://localhost:8000/api/'


const BASE = 'prospects/dashboard-kpis/';
const ANALYTICS_BASE = 'prospects/dashboard-analytics/';  // ← AJOUTER

export const getKPIs = async () => {
  try {
    const res = await api.get(BASE);
    return res.data?.kpis || {};
  } catch (error) {
    console.error('❌ Erreur récupération KPI:', error);
    throw error;
  }
};

// ← AJOUTER cette fonction
export const getAnalyticsData = async () => {
  try {
    const res = await api.get(ANALYTICS_BASE);
    return res.data;
  } catch (error) {
    console.error('❌ Erreur récupération analytics:', error);
    throw error;
  }
};

export const getDashboardData = async () => {
  try {
    const res = await api.get(BASE);
    return res.data;
  } catch (error) {
    console.error('❌ Erreur récupération dashboard:', error);
    throw error;
  }
};

export const getColorClass = (type) => {
  const colors = {
    hot: 'bg-gradient-to-br from-orange-500 to-red-600',
    medium: 'bg-gradient-to-br from-yellow-400 to-yellow-500',
    cold: 'bg-gradient-to-br from-blue-500 to-blue-600',
    score: 'bg-gradient-to-br from-purple-500 to-purple-600',
    urgent: 'bg-gradient-to-br from-red-600 to-red-700',
  };
  return colors[type] || 'bg-gradient-to-br from-gray-500 to-gray-600';
};

export const formatKPIsForDisplay = (kpis) => {
  if (!kpis) return [];

  return [
    {
      id: 'hot',
      label: 'Prospects chauds (cette semaine)',
      icon: '🔥',
      value: kpis.hot_prospects || 0,
      
      color: 'hot',
      trend: kpis.hot_week_change || '0',  // Comparaison avec semaine dernière
    },
    {
      id: 'medium',
      label: 'Prospects moyens (cette semaine)',
      icon: '🟡',
      value: kpis.medium_prospects || 0,
      
      color: 'medium',
      trend: kpis.medium_week_change || '0',
    },
    {
      id: 'cold',
      label: 'Prospects froids (cette semaine)',
      icon: '❄️',
      value: kpis.cold_prospects || 0,
      
      color: 'cold',
      trend: kpis.cold_week_change || '0',
    },
// Dans dashboardAiService.js - formatKPIsForDisplay
{
  id: 'score',
  label: 'Score moyen IA',
  icon: '📈',
  value: `${kpis.average_score || 0}%`,
  trend: kpis.average_score_week_change || '0',
  lastWeekValue: kpis.average_score_last_week || 0,  // ← AJOUTER CETTE LIGNE
  interpretation: kpis.average_score_interpretation || '💭',
  color: 'score',
  subtitle: `(vs ${kpis.average_score_last_week || 0}% semaine dernière)`,
},
    {
      id: 'urgent',
      label: 'Relances urgentes',
      icon: '⏰',
      value: kpis.urgent_followups || 0,
      interpretation: kpis.urgent_interpretation || '💭',
      color: 'urgent',
    },
  ];
};


// src/services/bi/dashboardAiService.js (ajouter à la fin)

const PRIORITY_FORMATIONS_BASE = 'prospects/formations-prioritaires/';
const PROSPECTS_BY_FORMATION_BASE = 'prospects/formations/';

export const getPriorityFormations = async (minHot = 5) => {
  try {
    const res = await api.get(`${PRIORITY_FORMATIONS_BASE}?min_hot=${minHot}`);
    return res.data;
  } catch (error) {
    console.error('❌ Erreur récupération formations prioritaires:', error);
    throw error;
  }
};

export const getProspectsByFormation = async (formationId) => {
  try {
    const res = await api.get(`${PROSPECTS_BY_FORMATION_BASE}${formationId}/prospects/`);
    return res.data;
  } catch (error) {
    console.error(`❌ Erreur récupération prospects pour formation ${formationId}:`, error);
    throw error;
  }
};